module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Herman C. Waetjen, Dr. Theol (Eberhard-Karls University of Tübingen, Germany), taught in the School of Religion of the University of Southern California, and as the Robert S. Dollar Professor of New Testament at San Francisco Theological Seminary in San Anselmo and the Graduate Theological Union in Berkeley for 40 years. He is the author of five books: "), _c('em', [_vm._v("Matthew’s Theology of Fulfillment, The Letter to the Romans: Salvation as Justice and the Deconstruction of Law, The Gospel of the Beloved Disciple: A Work in Two Editions, Praying the Lord’s Prayer,")]), _vm._v(" and "), _c('em', [_vm._v("A Reordering of Power: A Socio-Political Reading of Mark’s Gospel.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0